import DisciplineActivityCard from "../DisciplineActivityCard";
import { Typography } from "../../../../../core/components/molecules/Typography";
import { useGetHubDailyActivity } from "../../../hooks/ScheduleHub/useGetHubDailyActivity";
import BrainLoadingWrapper from "../../../../../core/components/molecules/BrainLoading";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IScheduleArrays } from "../../../model/ScheduleHub";
import { format, isWithinInterval } from "date-fns";
import { getDayName } from "../../../../../core/utils/dataTools";

interface IDayActivityCard {
  cronogramaId?: string;
  weeks?: IScheduleArrays[];
  refreshTrigger?: number;
}

const DayActivityCard: React.FC<IDayActivityCard> = ({
  cronogramaId,
  weeks,
  refreshTrigger,
}) => {
  const navigate = useNavigate();

  const {
    mutate,
    isPending: isPendingActivities,
    data: activities,
  } = useGetHubDailyActivity();

  useEffect(() => {
    if (cronogramaId) {
      mutate(cronogramaId);
    }
  }, [cronogramaId, refreshTrigger]);

  const showContent = () => {
    if (isPendingActivities || !cronogramaId) {
      return <BrainLoadingWrapper type='secondary' />;
    }

    if (!activities || activities.length === 0) {
      return (
        <div className='h-full flex flex-col justify-center'>
          <Typography
            type='p'
            className='text-md font-normal italic text-mono-color-white'
          >
            Não há atividades previstas para hoje.
          </Typography>
        </div>
      );
    }

    return (
      <div className='mt-4 flex max-h-[360px] flex-col gap-2 overflow-y-auto'>
        {activities.map((activity) => (
          <DisciplineActivityCard
            key={activity.discipline}
            discipline={activity.discipline}
            progress={activity.progress}
            isRevision={activity.isRevision}
            isCompleted={activity.isCompleted}
            originalDay={activity.originalData ? format(new Date(activity.originalData), 'dd/MM/yyyy') : undefined}
            onCardClick={() => {
              const activityDate = activity.originalData
                ? new Date(activity.originalData)
                : new Date();
              const dayName = getDayName(activityDate.toISOString());
              handleCardClick(dayName, activity.discipline, activityDate);
            }}
          />
        ))}
      </div>
    );
  };

  const handleCardClick = (day: string, discipline: string, activityDate?: Date) => {
    const dateToCheck = activityDate || new Date();
    const actualWeek = weeks?.find((week) =>
      isWithinInterval(dateToCheck, {
        start: new Date(week.start),
        end: new Date(week.end),
      })
    ) ?? weeks?.[0];

    const isoDate = format(dateToCheck, 'yyyy-MM-dd');
    navigate(
      `/plano-adaptativo/${cronogramaId}/dia?dia=${day}&materia=${discipline}&semana=${actualWeek?.number}&data=${isoDate}`
    );
  };

  return (
    <div
      data-tour="day-activity-card"
      className={`
        flex flex-col ${!activities || activities.length === 0 ? 'h-[360px]' : 'h-fit'}
        justify-between rounded-lg bg-brand-color-primary-pure p-5 dark:bg-brand-color-primary-light
      `}
    >
      <Typography
        type='title'
        className='text-h3 text-mono-color-white sm:text-h2 md:text-h1'
      >
        Atividades do dia
      </Typography>
      {showContent()}
    </div>
  );
};

export default DayActivityCard;
